let seed = 1;
function random(_seed) {
  if (_seed) {
    seed = _seed;
  }
  const x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
}
export default random;
